import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const SelectOptions = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/select-options/components/SelectOptionsContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/select-options/components/SelectOptionsHeader'
      )
  )
};

export default SelectOptions;
